import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

export const SITE_URL = "https://www.linaimmo.com";

// Browser tab title (« … | Lina Immo », in the current language) and canonical address of a page.
// Listing, holiday rental and search detail pages get their canonical from the server (shared preview):
// they pass no `path`, so the page never carries two canonical links.
export default function PageMeta({ titleKey, values, title, path }) {
  const { t } = useTranslation();
  const text = (title && String(title).trim()) || (titleKey ? t(titleKey, values) : "");
  return (
    <Helmet>
      {text && <title>{`${text} | Lina Immo`}</title>}
      {path && <link rel="canonical" href={SITE_URL + path} />}
    </Helmet>
  );
}
